import React from 'react';
import { MARKETS } from '../lib/config';

// Placeholder charts workspace. The real build wires a charting library
// (canvas/WebGL) + a websocket market-data feed to the CCFOS API (see CLAUDE.md).
const ChartsPage: React.FC = () => {
  return (
    <>
      <section className="page-head">
        <h1>Charts</h1>
        <p className="page-sub">Charting workspace — coming soon.</p>
      </section>

      <div className="market-grid">
        {MARKETS.map((m) => (
          <div key={m} className="market-tile">
            <span className="market-name">{m}</span>
            <span className="market-soon">soon</span>
          </div>
        ))}
      </div>

      <div className="stub-panel">
        <p>
          This is where interactive charts and CCFOS indicators will live. Data will
          stream from the CCFOS API over a websocket; charts render client-side. All
          views are <strong>educational illustrations only</strong>.
        </p>
      </div>
    </>
  );
};

export default ChartsPage;
